import { FC } from 'react'
import styles from './index.module.scss'
import { sanitizeUrl } from '../../../utils'

type Props = {
  twitterUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  githubUrl?: string
  telegramUrl?: string
  openseaUrl?: string
  linkedInUrl?: string
  discordUrl?: string
}

export const SnsLinkIconGroup: FC<Props> = ({
  twitterUrl,
  facebookUrl,
  instagramUrl,
  githubUrl,
  telegramUrl,
  openseaUrl,
  linkedInUrl,
  discordUrl,
}) => {
  return (
    <div className={styles.container}>
      {twitterUrl && (
        <a href={sanitizeUrl(twitterUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/twitter_icon.png' alt='Twitter' className='img-fluid' />
        </a>
      )}
      {facebookUrl && (
        <a href={sanitizeUrl(facebookUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/facebook_icon.png' alt='Facebook' className='img-fluid' />
        </a>
      )}
      {instagramUrl && (
        <a href={sanitizeUrl(instagramUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/instagram_icon.png' alt='Instagram' className='img-fluid' />
        </a>
      )}
      {githubUrl && (
        <a href={sanitizeUrl(githubUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/github_icon.png' alt='Github' className='img-fluid' />
        </a>
      )}
      {telegramUrl && (
        <a href={sanitizeUrl(githubUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/telegram_icon.png' alt='Telegram' className='img-fluid' />
        </a>
      )}
      {openseaUrl && (
        <a href={sanitizeUrl(openseaUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/opensea_icon.png' alt='Opensea' className='img-fluid' />
        </a>
      )}
      {linkedInUrl && (
        <a href={sanitizeUrl(linkedInUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/linkedIn_icon.png' alt='LinkedIn' className='img-fluid' />
        </a>
      )}
      {discordUrl && (
        <a href={sanitizeUrl(githubUrl)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          <img src='/images/common/discord_icon.png' alt='Discord' className='img-fluid' />
        </a>
      )}
    </div>
  )
}
